export class Compensation {
    compensationID: number;
    contactID: number;
    compensationDate: Date = new Date();
    description: string;
    subject: string;
}
